/** Only client portal destinations can continue through a client sign-in. */
export function safePortalReturn(value: string | null | undefined): string | null {
  if (!value || value.length > 2048 || /[\s\\#\u0000-\u001f\u007f]/.test(value)) return null;
  return value === '/portal' || value.startsWith('/portal?') ? value : null;
}

export function clientSignInPath(returnTo?: string | null): string {
  const next = safePortalReturn(returnTo);
  return next && next !== '/portal' ? `/client-login?${new URLSearchParams({ next })}` : '/client-login';
}

export function passwordRecoveryPath(client: boolean, returnTo?: string | null): string {
  const params = new URLSearchParams();
  if (client) params.set('for', 'client');
  const next = client && safePortalReturn(returnTo);
  if (next && next !== '/portal') params.set('next', next);
  return `/forgot-password${params.size ? `?${params}` : ''}`;
}
